import { createFileRoute } from "@tanstack/react-router"

import { validateUserAddPermission } from "@/lib/api/auth"
import { ConsumerForm } from "@/components/forms/consumer-form"
import { Header } from "@/components/header"

export const Route = createFileRoute("/_home/manage-consumers/add")({
  beforeLoad: async () => {
    validateUserAddPermission()
  },
  component: AddConsumersPage,
})

function AddConsumersPage() {
  return (
    <main className="space-y-4 p-4">
      <Header
        subroutes={[
          {
            route: "/manage-consumers",
            label: "Manage Consumers",
          },
        ]}
      >
        Add Consumers
      </Header>
      <ConsumerForm />
    </main>
  )
}
